export const WEBMAIL_URL = import.meta.env.DEV
  ? 'http://localhost:5174'
  : (import.meta.env.VITE_WEBMAIL_URL || 'https://webmail.purpletoadmail.com')

export const DOCS_URL = import.meta.env.VITE_DOCS_URL || 'https://docs.purpletoadmail.com'

export const API_DOCS_URL = import.meta.env.VITE_API_DOCS_URL || 'https://docs.purpletoadmail.com/api'
